export default {
    //Notifications
    Notifications: [],
    UserNotifications: [],
}